import { render, staticRenderFns } from "./PolicyNumberFormat.vue?vue&type=template&id=32c90ba0"
import script from "./PolicyNumberFormat.vue?vue&type=script&lang=ts"
export * from "./PolicyNumberFormat.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports